import React from 'react';
import { useLocation } from 'react-router-dom';
import CustomerInfoCard from './CustomerInfoCard';
import CustomerAddNewActionCard from './CustomerAddNewActionCard';
import Card from '@mui/material/Card';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

export default function CustomerNewCustomer() {
  const location = useLocation();
  const [useType, setUseType] = React.useState(localStorage.getItem('type'));

  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Card
      sx={{
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        padding: '10px',
      }}
    >
      <CustomerInfoCard
        customerData={location.state}
        postUri='/api/customersv2'
      />
      {/* <CustomerAddNewActionCard
        customerData={location.state.customerBranchName}
      /> */}
    </Card>
  );
}
